import { getBackendBaseUrl } from '@/services/backendConfig';

// ==========================================
// Winnery Gateway API — TypeScript Types
// ==========================================

// === Currencies ===

export interface CurrencyPreset {
  value: number;        // Preset value for calculator button
  label: string;        // Display label without a currency marker
}

export interface WinneryCurrency {
  id: string;
  code: string;         // e.g. "USD", "EUR", "RUB"
  name: string;         // e.g. "US Dollar"
  default: boolean;     // Is this the default currency?
  decimals: number;     // Number of decimal places (e.g. 2 for USD)
  presets: number[];    // Calculator preset values [1, 2, 5, 10, 25, 50, 100]
}

// === Player Session ===

export interface WinneryPlayerSession {
  id: string;                // Session ID
  player_id: string;         // Player ID
  currency_code: string;     // Player's currency code
  language: string;          // Player's language (e.g. "en", "ru")
  status: 'active' | 'expired' | 'closed';
}

// === Wallet / Balance ===

export interface WinneryBalance {
  amount: number;            // Balance in smallest units (cents)
  amount_human: string;      // Human-readable formatted balance (e.g. "1 250.00")
  currency_code: string;     // Currency code
}

// === API Response wrappers ===

export interface WinneryApiResponse<T> {
  success: boolean;
  data: T;
  error?: string;
}

// === Session Store State ===

export interface SessionState {
  // Connection
  sessionId: string | null;        // From URL query param
  isConnected: boolean;            // API connection established
  isLoading: boolean;              // Loading state
  error: string | null;            // Last error message
  
  // Player
  playerId: string | null;
  language: string;
  
  // Currency & Balance
  currencyCode: string;
  currencyDecimals: number;
  currencies: WinneryCurrency[];
  balance: string;                 // Human-readable balance from API
  balanceRaw: number;              // Raw balance in smallest units
  
  // Calculator presets
  presets: number[];               // Bet presets for current currency
  
  // Demo mode (no session_id)
  isDemoMode: boolean;
}

// === Config ===

export interface WinneryConfig {
  baseUrl: string;                 // Backend API base URL
  timeout: number;                 // Request timeout in ms
}

// Default config — will be overridden by env vars
export const DEFAULT_WINNERY_CONFIG: WinneryConfig = {
  baseUrl: getBackendBaseUrl(),
  timeout: 10000,
};







